import './styles.css';
import { ContentCopy, CoPresent, VolunteerActivism, ContactMailRounded, Instagram, LinkedIn, Facebook, QueueMusic } from '@mui/icons-material';
import { Paper, Divider, Button, Link} from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Grid, Typography, IconButton } from '@material-ui/core';
import { useState } from 'react';
import SEO from '../../common/SEO';

const aboutPageData = [
	{
		title: 'Contact',
		titleIcon: <ContactMailRounded style={{color: ' #ffffff'}} fontSize='large' />,
		photo: '',
		text: [
			'I appreciate your feedback. Any feedback or idea you would like to share please contact me at the below email address!',  
			'Online lessons are also available in English and Mandarain Chinese. Please feel free to enquire.',
			'If you have discovered an error, please help by reporting it with some description on how you found it. A screen shot would also be super useful!',
		],
		linkButtonText: null,
		mediaData: [
			{
				mediaName: 'violinscope@gmail.com',
				mediaUrl: 'violinscope@gmail.com',
				mediaButtonIcon: <ContentCopy/>,
				mediaAction: 'email'
			}
		]
	},
	{
		title: 'Donate',
		titleIcon: <VolunteerActivism style={{color: ' #ffffff'}} fontSize='large'/>,
		photo: '',
		text: [
			'If ViolinScope has been helpful to your child or students, please consider making a donation to help maintaining and expanding this app. Any size of donation is greatly appreciated!' 
		],
		linkButtonText: 'Buy me a coffee',
		mediaData: []
	},
	{
		title: 'About',
		titleIcon: <CoPresent style={{color: ' #ffffff'}} fontSize='large'/>,
		photo: '../../../assets/images/author_bio_photo.jpeg',
		text: [
			'ViolinScope is created and developed by Joanne Chen, a professional violinist, teacher, and software developer based in London, UK. Joanne’s orchestral career has taken her to perform concerts all over the world with orchestras such as the Royal Philharmonic Orchestra, BBC Symphony Orchestra, the Philharmonia, and many more. She is also a dedicated teacher and held violin teaching positions in private, public and grammar schools. Joanne also gives private violin, piano and music theory lessons in her own home, and worked as a software developer for Degree53 and Century Tech.',
			"ViolinScope is not designed to replace violin teachers, instead, it is a collection of free and simple tools for teachers or parents to recommend their young learners to use at home to help them gain insights on how the violin works 'visually'.", 
			"With years of teaching experience, Joanne found that struggling to read notes, learn new music and understand basic music theory is a common problem amongst many violin beginners. Therefore the main aims of ViolinScope is to get learners to use those game-like tools 'repetitively' to practice reading and locating notes on the violin, and once these essential skills are improved, the learners will be able to learn music faster and play with more confidence, and lesson times will become more available to discuss other musical and technical issues."
		],
		linkButtonText: null,
		mediaData: [
			{
				mediaName: 'Duo Kolibri',
				mediaUrl: 'https://duokolibri.com/index.php/media/',
				mediaButtonIcon: <QueueMusic />,
				mediaAction: 'duoKolibri'
			},
			{
				mediaName: 'Instagram',
				mediaUrl: 'https://www.instagram.com/joanne_chen_violinist/',
				mediaButtonIcon: <Instagram/>,
				mediaAction: 'instagram'
			},
			{
				mediaName: 'Facebook',
				mediaUrl: 'https://www.facebook.com/joanne.chen.5496683',
				mediaButtonIcon: <Facebook/>,
				mediaAction: 'facebook'
			},
			{
				mediaName: 'LinkedIn',
				mediaUrl: 'https://www.linkedin.com/in/joanne-chen-1253319b/',
				mediaButtonIcon: <LinkedIn/>,
				mediaAction: 'linkedIn'
			},
			
		]
	},
]


const AboutPage = () => {
	const [openTooltipAction, setOpenTooltipAction] = useState(undefined);
	const [tootipMessage, setTooltipMessage] = useState('');

	const mediaButtonOnClick = (mediaAction, mediaUrl) => {
		if(mediaAction === 'email') {
			navigator.clipboard.writeText(mediaUrl);
			setTooltipMessage(`Copied: ${mediaUrl}`);
			setOpenTooltipAction(mediaAction);
			setTimeout(() => 	setOpenTooltipAction(undefined), 3000);
		}
	}

	return (
		<>
			<SEO pageName="about"/>
			<div style={{marginTop: '25px', marginBottom: '25px'} }>

				<Grid container direction="row" spacing={6} justifyContent='space-around'>
					{aboutPageData.map(item => (
						<Grid item xs={12} sm={10} md={6} lg={5} key={item.title}>
							<Paper className="aboutPageWidgetPaper" style={{borderRadius: 10, backgroundImage:'linear-gradient(170deg, #08445e, #c2c2d6)', padding: 10, height: '100%'}}>
								<IconButton
									size="medium"
									sx={{ ml: 2 }}
									disabled
									>
								{item.titleIcon} 
								</IconButton>
								<Typography variant='h6' className='textColor' >{item.title}</Typography>
								<Divider variant="middle" style={{borderColor: ' #ffffff', margin: '10px'}}/>
								<div style={{textAlign: 'left'}}>
									{!!item.photo &&
										<img 
										src={item.photo}
										style={{maxWidth: '100%'}}
										alt={item.photo.replace('../../../assets/images/', '')}
										
										/>
									}
									{item.text.map(paragraph => (
										<Typography variant='body1' className="textColor" style={{ paddingBottom: 20}} key={paragraph}>{paragraph}</Typography>
										
									))}
									{item.mediaData &&
										item.mediaData.map(media => (
											<Grid container direction="row" justifyContent="center" alignItems='center' spacing={2} key={media.mediaAction}>
												<Grid item>
													<Link
														href={media.mediaAction === 'email' ? `mailto:${media.mediaUrl}` : media.mediaUrl}
														underline='none'
														target={media.mediaAction === 'email' ? '_self' : '_blank'}
														rel="noreferrer"
														>
														<Typography variant='body1' className="textColor" key={media.mediaName}>{media.mediaName}</Typography>
													</Link>
												</Grid>
												<Grid item>
													<Tooltip
														id={media.mediaAction}
														onClose={() => setOpenTooltipAction(undefined)}
														open={openTooltipAction === media.mediaAction }
														disableFocusListener
														disableHoverListener
														disableTouchListener
														title={tootipMessage}
														slotProps={{
															popper: {
																disablePortal: true,
																sx: {[`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: { padding: '10px'}}  
															}
														}}
														arrow
														>
														<IconButton 
															style={{color: ' #f0f0f5', boxShadow: '2px 2px 4px #000000'}} 
															onClick={() => mediaButtonOnClick(media.mediaAction, media.mediaUrl)}
															href={media.mediaAction !== 'email' ? media.mediaUrl : ''}
															target="_blank"
															rel="noreferrer"
															>
														{media.mediaButtonIcon}
														</IconButton>
													</Tooltip>												
												</Grid>
											</Grid>
										))
									}
								</div>
									{item.linkButtonText && 
										<>
											<Link href="https://buymeacoffee.com/violinscope" target="_blank" rel="noopener noreferrer">
												<Button style={{textTransform: 'none', width: '70%'}} color='secondary' variant='contained'  onClick={() => null}>
													<img
														className="coffeeImage"
														src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg"
														alt="Buy me a coffee"
													/>		
													<span className="coffeeButtonText">
														{item.linkButtonText}
														
													</span>
												</Button>
											</Link>
										</>
									}
							</Paper>
						</Grid>
					))}
				</Grid>
			</div>
		</>
	)
}

export default AboutPage;